import { APIEvent } from '../events/apiEvent'
import { EventBus } from '../event-bus'
import { StatusBarEvent } from '../events/statusBarEvent'

export default {

  mounted: function () {
    if (window.localStorage.getItem('token') === null) {
      this.$store.dispatch(APIEvent.LOGOUT, {})
    } else {
      if (this.$router.currentRoute.params.hasOwnProperty('role_ID') && this.$router.currentRoute.path !== '/userlist') {
        this.roleSelection = this.$router.currentRoute.params.role_ID.slice(8)
      } else { this.roleSelection = this.$store.state.roleID }

      EventBus.$on('role-selected', ({
        roleSelection
      }) => {
        this.roleSelection = roleSelection
        document.getElementById('statusFilter').value = roleSelection
      })

      // if (this.$store.state.userRoles.length < 1) {
      if (typeof this.$store.state.userRoles === 'undefined') {
        let options = {}
        options.start_record = '0'
        this.$store.dispatch(APIEvent.FETCH_USER_ROLES, options)
          .then(() => {
            this.fetchRoles()
          })
      } else {
        this.fetchRoles()
      }

      this.$store.dispatch(APIEvent.FETCH_TENANT_GROUPS, {})
        .then(() => {
          this.tenantGroupList = this.$store.state.tenantGroupList
        })
        .catch(this.handleError)
      if (this.$store.state.languageList.length < 1) {
        this.$store.dispatch(APIEvent.FETCH_LANGUAGE_LIST, {})
          .then((res) => {
            console.log(res)
          })
      }
    }
  },
  destroyed: function () {
    let options = {}
    options.prop = 'SET_USER_ROLES'
    options.value = []
    // console.log('destroyed:' + ' ' + options)
    this.$store.dispatch(APIEvent.CLEAR, options)
  },

  computed: {
    userList: function () { return this.$store.state.userList },
    tenants: function () { return this.$store.state.tenantsList },
    languages: function () {
      let options = []
      let defaultOpt = {}
      defaultOpt.value = null
      defaultOpt.text = 'Please select...'
      defaultOpt.disabled = true
      options.push(defaultOpt)

      let langs = this.$store.state.languageList
      for (let i = 0; i < langs.length; i++) {
        const lang = langs[i]
        let option = {}
        option.value = lang.id
        option.text = lang.description
        options.push(option)
      }
      return options
    }
  },

  data: function () {
    return {
      userRoles: [],
      tenantGroupName: '',
      startOffset: 0,
      selectedCount: 0,
      tenantSelection: null,
      selected: {
        selectedTenantID: null,
        selectedTenantName: null,
        selectedTenantGroup: null,
        selectedTenantGroupName: null
      },
      roleSelection: this.roleSelection,
      perPage: 20,
      currentPage: 1,
      hasNextPage: false,
      pageNumber: 1,
      tenantGroupList: [],
      selectedUser: {},
      newUser: {},
      newUserData: {
        email: '',
        role: null,
        tenant: null,
        tenantGroup: null,
        tenantGroupName: null,
        language: null
      },
      fields: {
        username: {
          label: 'Email',
          tdClass: 'width-250'
        },
        first_name: {
          label: 'First Name',
          tdClass: 'width-100'
        },
        last_name: {
          label: 'Last Name',
          tdClass: 'width-100'
        },
        XaTenant_ID: {
          label: 'Tenant ID',
          tdClass: 'width-100'
        },
        tenantName: {
          label: 'Tenant',
          tdClass: 'width-100',
          formatter: this.getTenantName
        },
        reset: {
          label: 'Action',
          tdClass: 'width-100'
        }
      },
      pageOptions: [
        {text: 5, value: 5},
        {text: 10, value: 10},
        {text: 20, value: 20},
        {text: 50, value: 50},
        {text: 100, value: 100},
        {text: 200, value: 200}
      ]
    }
  },

  methods: {
    initRoleSelection: function () {
      EventBus.$on('role-selected', roleSelection => {
        document.getElementById('statusFilter').value = roleSelection
        this.roleSelection = roleSelection
      })
    },
    compare: function (obj1, obj2) {
      const serviceA = obj1.service
      const serviceB = obj2.service

      let comparison = 0
      if (serviceA > serviceB) {
        comparison = 1
      } else if (serviceA < serviceB) {
        comparison = -1
      }
      return comparison
    },
    sort: function (obj1, obj2) {
      const nameA = obj1.name
      const nameB = obj2.name

      let comparison = 0
      if (nameA > nameB) {
        comparison = 1
      } else if (nameA < nameB) {
        comparison = -1
      }
      return comparison
    },
    fetchRoles: function () {
      /*
      let options = {}
      options.fetch_size = this.perPage.toString()
      options.start_record = this.startOffset.toString()
      if (this.roleSelection !== undefined) {
        options.role_id = this.roleSelection.toString()
      }
      */
      let options = {}
      options.start_record = '0'
      this.$store.dispatch(APIEvent.FETCH_USER_ROLES, options)
        .then((res) => {
          this.userRoles = res.data.list.role.sort(this.compare)
          this.hasNextPage = res.data.LastPage === '0'
        })
        .catch(this.handleError)
    },
    fetchUsers: function () {
      let options = {}
      options.fetch_size = this.perPage.toString()
      options.start_record = this.startOffset.toString()
      if (this.roleSelection !== undefined) {
        options.role_id = this.roleSelection.toString()
      }
      this.$store.dispatch(APIEvent.FETCH_USERS, options)
        .then((res) => {
          this.hasNextPage = res.data.LastPage === '0'
        })
        .catch(this.handleError)
    },
    onChange: function () {
      this.startOffset = 0
      this.pageNumber = 1
    },
    reset: function (data) {
      let options = {}
      options.account_id = data.item.id
      this.$store.dispatch(APIEvent.RESET_2FA, options)
        .then(() => {
          EventBus.$emit(StatusBarEvent.SUCCESS, '2FA successfuly reset')
        })
        .catch(this.handleError, 'The Reset can not be completed.Please check and try again')
    },
    getTenantName: function (val, key, item) {
      let id = item.XaTenant_ID
      for (let i = 0; i < this.tenants.length; i++) {
        let tenant = this.tenants[i]
        if (tenant.id === id) {
          return tenant.name
        }
      }
    },
    showUserDetails: function (data) {
      this.selectedUser = Object.assign({}, data.item)
      // interim set default value to null
      this.selectedUser.tenantGroup = null
      this.selectedUser.tenantGroupName = null
      this.$refs.userDetails.show()
    },
    updateUser: function () {
      let changes = this.findUserChanges()
      if (changes.length > 0) {
        let options = {}
        options.account_id = this.selectedUser.id
        for (let i = 0; i < changes.length; i++) {
          const prop = changes[i]
          options[prop] = this.selectedUser[prop]
        }
        this.$store.dispatch(APIEvent.UPDATE_ACCOUNT, options)
          .then(() => {
            this.fetchUsers()
            EventBus.$emit(StatusBarEvent.SUCCESS, 'User details successfuly updated')
          })
          .catch(this.handleError)
      }
    },
    findUserChanges: function () {
      let props = ['first_name', 'last_name', 'mobile_number', 'username']
      let changes = []
      let changedUser = this.selectedUser
      for (let i = 0; i < this.userList.length; i++) {
        const user = this.userList[i]
        if (user.id === changedUser.id) {
          for (let j = 0; j < props.length; j++) {
            let prop = props[j]
            if (user[prop] !== changedUser[prop]) {
              changes.push(prop)
            }
          }
          break
        }
      }
      return changes
    },
    addUserClicked: function () {
      this.setupModal()
    },
    setupModal: function () {
      this.tenantGroupName = ''
      this.selected.name = ''
      this.newUser = Object.assign({}, this.newUserData)
      this.$refs.addNewUser.show()
    },
    fetchTenantsInGroup: function () {
      let options = {}
      this.$store.dispatch(APIEvent.USER_TENANT_LIST, {})
        .then((res) => {
          this.userTenantsList = res.data.tenants
          for (var i = 0; i < this.userTenantsList.length; i++) {
            if (this.userTenantsList[i].id === this.selectedTenantID) {
              if (this.userTenantsList[i].tenant_group_name !== 'null') {
                this.tenantGroupName = this.userTenantsList[i].tenant_group_name
                if (this.newUser.tenantGroup === '1') {
                  options.tenant_group_id = this.userTenantsList[i].tenant_group_id
                  this.$store.dispatch(APIEvent.FETCH_GROUP_TENANTS, options)
                } else { options.tenant_group_id = '' }
              } else { this.tenantGroupName = '' }
            }
          }
        })
        .catch(this.handleError)
    },
    saveNewUser: function (event) {
      let message
      let email = this.newUser.email
      if (email.trim() === '' || !this.isEmailValid(email)) {
        event.preventDefault()
        EventBus.$emit(StatusBarEvent.WARNING, 'Please enter a valid email')
      } else if (!this.newUserValid()) {
        event.preventDefault()
        EventBus.$emit(StatusBarEvent.WARNING, 'Please complete all required fields')
      } else {
        let options = {}
        options.username = this.newUser.email
        options.role_id = this.newUser.role
        options.tenant_id = this.newUser.tenant
        options.language_id = this.newUser.language
        if (this.newUser.tenantGroup === '1') {
          options.tenant_group_id = this.selectedTenantGroup
        } else {
          options.tenant_group_id = ''
        }
        this.$store.dispatch(APIEvent.ADD_USER, options)
          .then((res) => {
            let data = {}
            data.user_id = res.data.id.toString()
            if (this.newUser.tenantGroup === '1') {
              data.tenant_group_id = this.selectedTenantGroup
              message = 'and assigned to a tenant group'
            } else {
              data.tenant_group_id = ''
              message = 'but not assigned to a tenant group'
            }
            this.$store.dispatch(APIEvent.UPDATE_USER_TENANT_GROUP, data)
              .then(() => {
              })
              .catch(this.handleError)
            EventBus.$emit(StatusBarEvent.SUCCESS, `User successfully added ${message}`)
          })
          .catch(this.handleError, 'The User can not be added. Please check and try again ::')
      }
    },
    isEmailValid: function (email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(email)
    },
    newUserValid: function () {
      let user = this.newUser
      let props = ['language', 'role', 'tenant']
      let valid = true
      for (let i = 0; i < props.length; i++) {
        const prop = props[i]
        if (user[prop] === null) {
          valid = false
          break
        }
      }
      return valid
    },
    handleError: function (error, message) {
      if (!error.error === 307) {
        message = typeof message === 'undefined'
          ? error.message
          : message + error.message
        EventBus.$emit(StatusBarEvent.ERROR, message)
      }
      if (error.error === 1003) {
        EventBus.$emit(StatusBarEvent.ERROR, error.message)
      }
    },
    page (event) {
      var next = event.currentTarget.className.indexOf('next') > -1
      if (next) {
        this.startOffset += this.perPage
        this.pageNumber++
      } else {
        this.startOffset -= this.perPage
        this.pageNumber--
      }
      this.fetchUsers()
    },
    tenantSelected () {
      if (typeof this.selected.id !== 'undefined') {
        this.selectedCount++
        EventBus.$emit('tenant-got-selected', this.selectedCount)
        this.selectedTenantID = this.selected.id
        this.selectedTenantName = this.selected.name
        this.selectedTenantGroup = this.selected.tenantGroup
        this.selectedTenantGroupName = this.selected.tenantGroupName
        this.newUser.tenant = this.selectedTenantID
        this.newUser.tenantGroup = this.selectedTenantGroup
        this.newUser.tenantGroupName = this.selectedTenantGroupName
        return this.selectedTenantID
      }
    }
  }
}
